import React, { useState, useRef } from "react";
import { TextField } from "@material-ui/core";
import axios from "axios";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import { isNumber } from "../../lib/Common";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Recommend(props) {
  const recommendName = (strPhoneValue) => {
    return new Promise(function (resolve, reject) {
      let urlJoin = props.url + "/api/specialMember/SpecialGetName";
      axios
        .post(
          urlJoin,
          {
            phone: strPhoneValue,
          },
          { withCredentials: true }
        )
        .then((response) => {
          if (response.data.CUST_NAME === "NO") {
            reject(-1);
          } else {
            setStrRecommendName(response.data.CUST_NAME);
            resolve(true);
          }
        })
        .catch((response) => {
          reject(-400);
        });
    });
  };
  const classes = props.useStyles();
  const [errorText, setErrorText] = useState("");
  const [strRecommendName, setStrRecommendName] = useState("");
  const [open, setOpen] = useState(false);
  const [errorValue, setErrorValue] = useState(false);
  const recommendRef = useRef(null);

  const handleAgreeClose = () => {
    setOpen(false);
    setErrorText(`추천인은 ${strRecommendName}님 입니다.`);
    setErrorValue(false);
    return;
  };
  const handleCancel = () => {
    recommendRef.current.focus();
    setOpen(false);
    return;
  };
  return (
    <>
      <TextField
        className={classes.TextField}
        fullWidth
        inputRef={recommendRef}
        error={errorValue}
        helperText={errorText}
        label="추천인휴대폰번호(Phone)"
        type="text"
        variant="filled"
        inputProps={{
          maxLength: 11,
        }}
        onBlur={(e) => {
          if (open === true) {
            e.target.value = "";
            props.onChangeRecommend(e.target.value);
            return;
          }
          if (e.target.value.length === 0) {
            setErrorText("");
            setErrorValue(false);
          } else if (
            !isNumber.test(e.target.value) ||
            (e.target.value.length <= 9 && e.target.value.length >= 1)
          ) {
            setErrorText(
              "휴대폰번호(숫자만 연속해서입력, 예: 01011112222) 입력하세요."
            );
            setErrorValue(true);
            recommendRef.current.focus();
          } else if (
            isNumber.test(e.target.value) &&
            e.target.value.length >= 10 &&
            e.target.value.length <= 11
          ) {
            if (!props.phone) {
              e.target.value = "";
              props.phoneRef.current.focus();
            } else {
              if (props.phone === e.target.value) {
                setErrorText("본인과 추천인 휴대폰번호는 같을 수 없습니다.");
                setErrorValue(true);
                recommendRef.current.focus();
                return;
              }
            }
            const no1 = ["010", "011", "016", "017", "018", "019"];
            // 20210610 휴대폰번호 체크로직 추가. 경민. 이민정과장 요청사항.
            if (no1.includes(e.target.value.substring(0, 3)) === false) {
              setErrorText(
                "휴대폰번호가 010/011/016/017/018/019 로 시작해야합니다. "
              );
              setErrorValue(true);
              recommendRef.current.focus();
              return;
            }
            recommendName(e.target.value).then(
              function (value) {
                if (value === true) {
                  props.onChangeRecommend(e.target.value);
                  setOpen(true);
                }
              },
              function (error) {
                switch (error) {
                  case -1:
                    setErrorText("추천인이 존재하지 않습니다.");
                    setErrorValue(true);
                    recommendRef.current.focus();
                    return;
                  case -400:
                    alert("서버 호출 에러");
                    return;
                  default:
                    alert("에러 호출번호 오류!!!!" + error);
                    return;
                }
              }
            );
          }
        }}
        name="recommend"
        defaultValue={props.recommend}
      />
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleAgreeClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-title">{`추천인이 '${strRecommendName}'님 맞습니까?`}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {`추천인 휴대폰번호로 '${strRecommendName}'님 검색 됩니다.`}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAgreeClose} color="primary" autoFocus>
            확인
          </Button>
          <Button onClick={handleCancel} color="primary">
            취소
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
export default Recommend;
